export default "__VITE_ASSET__dde45d03__"